import React from 'react';
import { Accordion, Box } from '@rsos/components/capstone/base';
import { AccordionContainer } from './RcsChat.styles';
import RcsStartChatMessages from './RcsStartChatMessages';
import usePreconfiguredMessages from './usePreconfiguredMessages';

const OFFSET_HEIGHT = 92; // height of the header above the start button

const RcsStartChatAccordion = ({
  isCreatingConversation,
  isForOverview = false,
  onClickShowAccordion,
  onStartConversation,
  showPreconfiguredMessages,
}) => {
  const preconfiguredMessages = usePreconfiguredMessages();

  return (
    <Box height="100%" horizontal mt="8px" width="100%" px="8px">
      <AccordionContainer showBorder={showPreconfiguredMessages} width="100%">
        <Accordion
          btnDisabled={isCreatingConversation}
          btnSize="med"
          btnPx="10px"
          callback={onClickShowAccordion}
          content={
            <RcsStartChatMessages
              isCreatingConversation={isCreatingConversation}
              preconfiguredMessages={preconfiguredMessages}
              onSendMessageClick={onStartConversation}
            />
          }
          header={null}
          headerIcon="chevron"
          headerPadding={isForOverview ? '0 16px' : '0 12px'}
          isOpened={showPreconfiguredMessages}
          interactionType="button"
          noBorder
          height={isForOverview ? '100%' : `calc(100% - ${OFFSET_HEIGHT}px)`}
          padding="0"
          width="100%"
        />
      </AccordionContainer>
    </Box>
  );
};

export default RcsStartChatAccordion;
